/**
 * abc-session.js
 * Reads URL params and referrer into window.__abc.session.
 * No consent required — nothing is persisted.
 * Fires: abc:sessionReady
 */
(function () {
  'use strict';

  var p = new URLSearchParams(location.search);

  window.__abc = window.__abc || {};
  window.__abc.session = {
    utmSource:   p.get('utm_source')   || '',
    utmMedium:   p.get('utm_medium')   || '',
    utmCampaign: p.get('utm_campaign') || '',
    utmContent:  p.get('utm_content')  || '',
    utmTerm:     p.get('utm_term')     || '',
    ref:         document.referrer     || '',
  };

  document.dispatchEvent(new CustomEvent('abc:sessionReady', { detail: window.__abc.session }));

})();
